import { Option } from '../../components/SelectFilter/SelectFilter';

/**
 * Icon keys a menu section can be tagged with. The terminal app bakes in the actual
 * icon artwork and renders it by matching this key — only the key string is persisted.
 *
 * To add/remove an option, edit this list AND make sure the terminal app has a matching
 * icon for the `value` key.
 */
export const SECTION_ICON_OPTIONS: Option<string>[] = [
  { value: 'burger', label: 'Burger' },
  { value: 'pizza', label: 'Pizza' },
  { value: 'salad', label: 'Salad' },
  { value: 'drinks', label: 'Drinks' },
  { value: 'dessert', label: 'Dessert' },
  { value: 'coffee', label: 'Coffee' },
  { value: 'seafood', label: 'Seafood' },
  { value: 'breakfast', label: 'Breakfast' },
  { value: 'wine', label: 'Wine' },
  { value: 'beer', label: 'Beer' },
  { value: 'cocktail', label: 'Cocktail' },
  { value: 'kids', label: 'Kids' },
  { value: 'vegan', label: 'Vegan' },
  { value: 'specials', label: 'Specials' },
];

export const getSectionIconOption = (icon?: string): Option<string> | null =>
  SECTION_ICON_OPTIONS.find((option) => option.value === icon) ?? null;
